import { useRef, type TouchEvent } from 'react';

/** Минимальный горизонтальный сдвиг, который считаем свайпом. */
const THRESHOLD_PX = 55;

/**
 * Горизонтальные свайпы по контенту.
 *
 * Вертикальная составляющая должна быть заметно меньше горизонтальной, иначе
 * обычная прокрутка списка превращалась бы в перелистывание дня.
 */
export function useSwipe(handlers: {
  /** Палец движется влево. */
  onLeft: () => void;
  /** Палец движется вправо. */
  onRight: () => void;
}) {
  const start = useRef<{ x: number; y: number } | null>(null);

  return {
    onTouchStart(e: TouchEvent) {
      const t = e.touches[0];
      start.current = t ? { x: t.clientX, y: t.clientY } : null;
    },
    onTouchEnd(e: TouchEvent) {
      const from = start.current;
      const t = e.changedTouches[0];
      start.current = null;
      if (!from || !t) return;

      const dx = t.clientX - from.x;
      const dy = t.clientY - from.y;
      if (Math.abs(dx) < THRESHOLD_PX || Math.abs(dx) < Math.abs(dy) * 1.5) return;

      if (dx < 0) handlers.onLeft();
      else handlers.onRight();
    },
  };
}
